import { render, staticRenderFns } from "./资料下载详情.vue?vue&type=template&id=71192baf&scoped=true"
import script from "./资料下载详情.vue?vue&type=script&lang=js"
export * from "./资料下载详情.vue?vue&type=script&lang=js"
import style0 from "./资料下载详情.vue?vue&type=style&index=0&id=71192baf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71192baf",
  null
  
)

export default component.exports